
const cdnFormula = 'https://content-f55.dev.55winers.com';
const cdnInbet = cdnFormula;
const cdnSmartsoftGaming = cdnFormula;

// const hostUrl = isDomainZone('boxbet') ? 'https://api-web.f55mapp4aws.org' : 'https://api.dev.55winers.com'
const config = {
  jivochat: true,
  cdn: cdnFormula,
  inbet: 'li8eiBai',
  host: 'https://api.dev.55winers.com',
  changeOddsHost: 'https://changeodds.dev.55winers.com/api',
  eventSearch: 'https://events-search.dev.55winers.com',
  socket: 'wss://ws-live.dev.55winers.com/ws',
  stream: 'https://5e993dcc4cda2.streamlock.net:8443',
  streamRu: 'https://st6.mediabay.tv',
  gpsTracker: 'https://gps-tracker.dev.55winers.com',
  billingHost: 'https://billing.dev.55winers.com',
  sportsBook: 'https://sports-dev.55winers.com',
  championUrl: 'https://championcasino.net',
  clientInfoHost: 'https://firebase.dev.55winers.com',
  miniGamesHost: 'https://mini-games.dev.55winers.com',
  maintenance: false,
  isNewYearMode: false,
  newYear: false,
  newYearDate: 'Jan 1, 2026 12:00:00',
  inbetHost: 'https://devslot55winers.vlobby.co',
  googleAnalyticsID: 'n/a',
  yandexAnalyticsID: 'n/a',
  googleTagManagerID: '',
  afkAppsScriptURL: '',
  afkTurnstileSiteKey: '',
  inbetBetPerLine: {
    TJS: [ 1, 2, 5, 10, 50 ],
    RUB: [ 5, 10, 20, 50, 100 ],
    UZS: [ 1000, 2000, 5000, 10000, 50000 ],
    USD: [ 1, 2, 5, 10, 50 ],
    EUR: [ 1, 2, 5, 10, 50 ],
    UAH: [ 1, 2, 5, 10, 50 ],
    KGS: [ 5, 10, 20, 50, 100 ],
  } as { [key: string]: number[] },

  sgames: {
    src: 'https://hub-web.rupr.upsl-tech.ru',
    cid: 'formula55tj',
    productId: 'sport-games-lobby',
  },

  internalKey: 'tj',
  domains: [],

  gpsAvailableCountries: [
    { id: 119, title: 'Kyrgyzstan', code: 'KG' },
    { id: 181, title: 'Russian Federation', code: 'RU' },
    { id: 213, title: 'Tajikistan', code: 'TJ' },
    { id: 227, title: 'Ukraine', code: 'UA' },
    { id: 233, title: 'Uzbekistan', code: 'UZ' },
  ],

  inbetList: [
    { class: 1, title: 'KENO LIVE', url: 'bet_keno', img: `${cdnInbet}/m_inbet/bet_keno.jpeg` },
    { class: 1, title: 'KENO NEON', url: 'bet_kenoneon', img: `${cdnInbet}/m_inbet/bet_kenoneon.jpeg` },
    { class: 1, title: 'KENO NIGHT', url: 'bet_kenonight', img: `${cdnInbet}/m_inbet/bet_kenonight.jpeg` },
    { class: 1, title: 'XKENO', url: 'bet_xkeno', img: `${cdnInbet}/m_inbet/bet_xkeno.jpeg` },
    { class: 1, title: 'PENALTY', url: 'bet_penalty', img: `${cdnInbet}/m_inbet/bet_penalty.jpeg` },
    { class: 1, title: 'VIRTUAL SOCCER', url: 'bet_vsoccer', img: `${cdnInbet}/m_inbet/bet_vsoccer.jpeg` },
    { class: 1, title: 'KENO DRAW', url: 'e_keno_draw', img: `${cdnInbet}/m_inbet/e_keno_draw.jpeg` },
    { class: 1, title: 'KENO DRAW 2', url: 'e_keno_draw2', img: `${cdnInbet}/m_inbet/e_keno_draw2.jpeg` },
	{ class: 1, title: 'Tubi Tilloi', url: 'e_mpt', img: `https://ibt.formula55play.space/media/thumb/500x500/e_mpt.jpeg` },
    { class: 1, title: 'Football Scratch', url: 'ibl_fs2', img: `https://ibt.formula55play.space/media/thumb/500x500/ibl_fs2.jpeg` },
    { class: 1, title: 'JX Keno', url: 'bet_jxkeno', img: `https://ibt.formula55play.space/media/thumb/500x500/bet_jxkeno.jpeg` },
  ],

  admiral: {
    host: 'https://admiral-casino.dev.55winers.com',
  },

  iosShowKeno: false,
  hideCasino: true,
  iosVersion: '1.2.9',

  feedback: {
    messengers: [
      { title: 'WhatsApp', url: 'https://wa.me/992940435555', icon: 'whatsapp', username: '992940435555' },
      { title: 'Viber', url: 'viber://chat?number=%2B992940435555', icon: 'viber', username: '992940435555' },
      { title: 'Telegram', url: 'tg://resolve?domain=F55_tj', icon: 'telegram', username: 'f55_tj' },
    ],
    socials: [
      {
        icon: 'facebook',
        url: 'https://www.facebook.com/pg/F55Tajikistan/posts/?ref=page_internal',
        title: 'Facebook',
      },
      { icon: 'instagram', url: 'https://www.instagram.com/bkformula55/', title: 'Instagram' },
      { icon: 'odnoklassniki', url: 'https://ok.ru/formula55tj', title: 'Odnoklassniki' },
      { icon: 'vk', url: 'https://vk.com/formula55', title: 'Vkontakte' },
    ],
    phones: [ '(+992) 37 221 5510', '(+992) 37 884 5555', '5500' ],
    emails: [ 'admin@formula55.tj' ],
    support: [],
  },

  languages: [
    { value: 'ru', label: 'Русский' },
    { value: 'en', label: 'English' },
    { value: 'tj', label: 'Тоҷикӣ' },
    { value: 'uz', label: 'O\'zbekcha' },
    { value: 'ua', label: 'Українська' },
    { value: 'kg', label: 'Кыргызча' },
  ],

  minBetAmount: 5,

  channelListRu: {
    1: { title: 1, name: 'FootballHD' },
    2: { title: 2, name: 'VarzishHD' },
    3: { title: 3, name: 'MatchHD' },
    4: { title: 4, name: 'MatchFutbol1' },
    5: { title: 5, name: 'MatchFutbol2' },
    6: { title: 6, name: 'MatchFutbol3' },
    7: { title: 7, name: 'MatchPremier' },
  } as Record<number, { title: number; name: string }>,

  eyeLiveSport: {
    api: 'https://eye-sports.dev.55winers.com',
    host: 'https://ui-stage.betsy.software',
    cid: 'formula55-stage',
    parent: 'https://yourdomain.com/',
    allowParentUrlUpdate: false,
  },

  ssgHost: 'https://eu-staging.ssgportal.com',
  ssgGames: [
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/xgames/balloon.jpeg`,
      name: 'Balloon',
      title: 'BALLOON',
      category: 'Games',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/xgames/cappadocia.jpeg`,
      name: 'Cappadocia',
      title: 'CAPPADOCIA',
      category: 'Games',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/xgames/cricketx.jpeg`,
      name: 'CricketX',
      title: 'CRICKET X',
      category: 'XGames',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/xgames/plinkox.jpeg`,
      name: 'PlinkoX',
      title: 'PLINKO X',
      category: 'Games',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/xgames/spinx.jpeg`,
      name: 'SpinX',
      title: 'SPIN X',
      category: 'XGames',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/xgames/jetx3.jpeg`,
      name: 'JetX3',
      title: 'JETX3',
      category: 'XGames',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/slots/burning_ice_10.jpeg`,
      name: 'BlazingHot10',
      title: 'BURNING ICE 10',
      category: 'Slots',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/slots/burning_ice_40.jpeg`,
      name: 'BlazingHot40',
      title: 'BURNING ICE 40',
      category: 'Slots',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/slots/kingdom_elves.jpeg`,
      name: 'Elves',
      title: 'THE KINGDOM OF ELVES',
      category: 'Slots',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/slots/magic_garden_fruid.jpeg`,
      name: 'Fruit5',
      title: 'MAGIC GARDEN',
      category: 'Slots',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/slots/multi_hot_5.jpg`,
      name: 'MultiHot5',
      title: 'MULTIHOT5',
      category: 'Slots',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/slots/zombies.jpeg`,
      name: 'Zombies',
      title: 'ZOMBIES',
      category: 'Slots',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/jetx/JetX_Page1-m.png`,
      name: 'jetX',
      title: 'JetX',
      category: 'jetX',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/keno/classic_keno.jpeg`,
      name: 'ClassicKeno',
      title: 'CLASSIC KENO',
      category: 'Keno',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/keno/russian_keno.jpeg`,
      name: 'RussianKeno',
      title: 'RUSSIAN KENO',
      category: 'Keno',
    },
    {
      img: `${cdnSmartsoftGaming}/ssgames/category/keno/vip_keno.jpeg`,
      name: 'VipKeno',
      title: 'VIP KENO',
      category: 'Keno',
    },
  ],
  ssgSliderSlides: [
    `${cdnSmartsoftGaming}/ssgames/swiper/Jetx-swiper-1-m.png`,
    `${cdnSmartsoftGaming}/ssgames/swiper/XGames-swiper-2-m.png`,
    `${cdnSmartsoftGaming}/ssgames/swiper/Slots-swiper-3-m.png`,
    `${cdnSmartsoftGaming}/ssgames/swiper/Casino-swiper-4-m.jpg`,
    `${cdnSmartsoftGaming}/ssgames/swiper/Keno-swiper-5-m.png`,
  ],

  sportradar: {
    api: 'https://sportradar.dev.55winers.com',
    iframe: {
      '/table-tennis': 'https://f55-dev.bets.osai.ai/#/bet',
      '/online-football': 'https://widget-esoccer-formula55.quickbets-nonprod.sportradar.dev/#/bet',
    },
  },

  appLinks: [
    'https://cdn.formula55.tj/apps/Formula55Android.apk',
    'https://apps.apple.com/tj/app/formula55/id1502992542',
  ] as string[],

  itunesLinks: 'itms-apps://itunes.apple.com/app/formula55/id1502992542' as string,
};

export default config;


